import { LazyLoadingSectionLogger, LoggingSection } from "@multiweb/logging";
import { Localization } from "OW.Remoting/Remoting/Localization";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { ContainerEditableControl } from "./ContainerEditableControl";
import { ControlParams } from "./ControlInterfaces";

const logger = LazyLoadingSectionLogger.create(LoggingSection.edit);

export class Edit extends ContainerEditableControl {
    //#region Constructors
    constructor(params: ControlParams) {
        super({ parentElement: params.element, originalRightsDefinition: params.originalRightsDefinition, logger });
    }
    //#endregion Constructors

    //#region Methods

    /** Pokud je zadan regexp, pak validuje podle nej, jinak vraci true. */
    public override validate(): boolean {
        if (this._validationExpr) {
            const el = this.innerElement;
            if (el.value.length === 0 || this._validationExpr.test(el.value)) {
                this.setValid();
                return true;
            } else {
                this.setInvalid("GUI-214428");
                return false;
            }
        } else {
            this.setValid();
        }

        return true;
    }

    public override setValid(): void {
        super.setValid();
    }

    /** Vytvori samotny input */
    protected override _createInput(): void {
        const input = createElement({ type: "input", attrs: { "type": "text" } }) as HTMLInputElement;

        if (this.maxLength) {
            input.maxLength = this.maxLength;
        }

        if (this._placeholderLocKey) {
            Localization.addLocTxtData(input, this._placeholderLocKey, "placeholder");
        }

        this.innerElement = input;
        this.innerElement.setAttribute("autocomplete", "off");
        this.element.appendChild(this.innerElement);

        if (this._language != null)
            this.innerElement.setAttribute("lang", this._language); //nastaveni jazyka pro kontrolu pravopisu language/data-lang
    }

    //events handlers
    protected override _pasteEventHandler(_e: Event): void {
        // Prázdná metoda
    }

    //#endregion Methods
}
